var _excluded = ["minDate", "maxDate", "excludeHolidays", "weekDays", "secondarySelectedDate", "showToday", "legendItems", "onSelect", "value", "backButton", "size", "trigger"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Menu } from '../../../containers/Menu';
import { useBreakpointValue } from '../../../theme';
import { forwardRef } from '../../../utils';
import { _DatePicker } from './_DatePicker';
import { jsx as _jsx } from "react/jsx-runtime";
export var DatePicker = forwardRef((_ref, ref) => {
  var {
    minDate,
    maxDate,
    excludeHolidays,
    weekDays,
    secondarySelectedDate,
    showToday,
    legendItems,
    onSelect,
    value,
    backButton,
    size,
    trigger
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var calendarProps = {
    minDate,
    maxDate,
    excludeHolidays,
    weekDays,
    secondarySelectedDate,
    showToday,
    onSelect,
    value,
    legendItems,
    backButton
  };
  var menuSize = useBreakpointValue({
    xs: size,
    s: 'fit-content'
  });
  return /*#__PURE__*/_jsx(Menu, _objectSpread(_objectSpread({
    "data-component": "DatePicker"
  }, props), {}, {
    trigger: trigger,
    size: menuSize,
    maxHeight: "100%",
    ref: ref,
    children: /*#__PURE__*/_jsx(_DatePicker, _objectSpread({}, calendarProps))
  }));
});
DatePicker.displayName = 'DatePicker';
//# sourceMappingURL=DatePicker.js.map